module.exports = __webpack_public_path__ + "img/btceyes.745e9d65.png";